// ** React Imports
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// ** Custom Hooks
import { useSkin } from "@hooks/useSkin";

import {
  toastStyle,
  isValidEmail,
  saveDataToLocalStorage
} from "../../utility/helper";
import { statusCode } from "../../utility/constants/utilObject";

import { redirectToLastUrl } from "../../utility/Utils";

// ** Third Party Components
import toast from "react-hot-toast";
import InsightAILogo from "../../assets/logo/nav/Logo-white.png";
import BG from '../../assets/images/backgrounds/bg-blue.png';
import { _parseDataToPayload } from "../../utility/constants/socialMediaPlatform";

// ** Actions
import { loginUserHandler } from "../../services/onboarding";

import GoogleSignInButton from "./socialLoginScreens/GoogleLoginBtn";

import InputPasswordToggle from "@components/input-password-toggle";
import "./index.scss";

// ** Reactstrap Imports
import {
  Form,
  Input,
  Label,
  Button,
  CardText,
  CardTitle,
  Col,
} from "reactstrap";

// ** Styles
import "@styles/react/pages/page-authentication.scss";
import { ClipLoader } from "react-spinners";

const REDIRECT_URI = `${window.location.origin}/login`;

const Login = () => {
  // ** Hooks
  const { skin } = useSkin();
  const navigate = useNavigate();
  localStorage.setItem("menuCollapsed", "false")

  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
    customer_type: "direct_client"
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  //Google Login
  const handleGoogleLogin = (userData) => {
    if (!userData) {
      return toast.error("Please provide all details", { ...toastStyle.error });
    }
    setLoader(true);
    loginUserHandler({
      email: userData.email,
      auth_token: userData.sub,
      customer_type: "direct_client"
    })
      .then((res) => {
        setLoader(false);
        if (res.status && res.status.toString() === statusCode.HTTP_200_OK) {
          const response = res.data.data;
          saveDataToLocalStorage(response);
          const featuresArray = [];
          localStorage.setItem('features', JSON.stringify(featuresArray));
          const isEmailVerified = response["is_email_verified"];
          if (!isEmailVerified) {
            window.location.replace("/verify-email")
            return;
          } else {
            toast.success("Welcome back " + response.first_name, { ...toastStyle.success });
            window.location.replace("/dashboard");
            // window.location.replace("/fiu-reporting");


            
    

            redirectToLastUrl();

          }

        } else {
          toast.error("No user found with this Email, Please create your account first!", { ...toastStyle.error });
        }
      })
      .catch((err) => {
        setLoader(false);
        return toast.error(`${err.message || "Incorrect credentials entered"}`, { ...toastStyle.error });
      });
  }

  // Use the login api to set up the access
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!data.email || !data.password) {
      return toast.error("Please provide all details", { ...toastStyle.error });
    } else if (!isValidEmail(data.email)) {
      return toast.error("Invalid email address", { ...toastStyle.error });
    } else if (data.email && data.password) {
      setLoader(true);
      loginUserHandler({
        email: data.email,
        password: data.password,
        customer_type: data.customer_type
      })
        .then((res) => {
          setLoader(false);
          console.log(res)
          if (res.status && res.status.toString() === statusCode.HTTP_200_OK) {
            const response = res.data.data;
            saveDataToLocalStorage(response);
            localStorage.removeItem('shopify');
            localStorage.removeItem('bot_config');
            localStorage.removeItem('bot_id');
            localStorage.removeItem('dashboard');
            localStorage.removeItem('pricing');
            localStorage.removeItem("user_type");

            const featuresArray = ['Home Loan Underwriting'];
            localStorage.setItem('features', JSON.stringify(featuresArray));


            const isEmailVerified = response["is_email_verified"];
            if (!isEmailVerified) {
              window.location.replace("/verify-email")
              return;
            }
            toast.success("Welcome back " + response.first_name, { ...toastStyle.success });
            navigate("/dashboard");
            // navigate('/fiu-reporting')
            // redirectToLastUrl();
          } else {
            toast.error(`${res.response && res.response.data && res.response.data.error ? res.response.data.error : "Unable to login, Please check your credentials."}`, { ...toastStyle.error });
          }
        })
        .catch((err) => {
          setLoader(false);
          return toast.error(`${err.message || "Incorrect credentials entered"}`, { ...toastStyle.error });
        });
    }
  };

  return (
    <div className="auth-wrapper auth-cover">

      <div className="auth-inner m-0 login-page">
        <div className="login-page__left" style={{ backgroundImage: `url(${BG})` }}>
          {/* Left Panel */}
          <Link className="brand-logo" to="/" onClick={e => e.preventDefault()}>
            <img src={InsightAILogo} style={{ width: "140px", height: "30px" }} alt={"logo"} />
          </Link>
          <div className="login-page__content">
            <h1 className="welcome-title">
              Welcome to Insight<span>AI</span>
            </h1>

            <p>Early Fraud Detection to Reduce Loss & Risk</p>
          </div>
        </div>


        {/* Right Panel */}
        <div className="login-page__right">


          <Col style={{
            paddingTop: '50px',
            borderRadius: '5px',
            paddingBottom: '50px',
          }} className="px-xl-2 mx-auto login-form" sm="8" md="6" lg="12">
            <CardTitle style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: '600' }} tag="h2" className=" mb-1">
              Sign In
            </CardTitle>
            <CardText style={{ textAlign: 'center' }} className="mb-2">Please sign-in to your account and start the adventure</CardText>
            {/* Third Party Sign In */}

            {/* <div className="auth-footer-btn d-flex justify-content-center">
              <GoogleSignInButton onSignInSuccess={handleGoogleLogin} />
            </div>
            <div className="divider my-2">
              <div className="divider-text">or</div>
            </div> */}

            {/* Email Sign in */}

            <Form style={{ width: '100%' }} className="auth-login-form mt-2" onSubmit={handleSubmit}>
              <div className="mb-1">
                <Label className="form-label" for="login-email">
                  Email
                </Label>
                <Input
                  type="email"
                  disabled={loader}
                  id="login-email"
                  placeholder="john@example.com"
                  autoFocus name="email" value={data.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-1">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" for="login-password">
                    Password
                  </Label>
                  <Link className={loader ? "disabled-link" : ""} to="/forgot-password">
                    <small>Forgot Password?</small>
                  </Link>
                </div>
                <InputPasswordToggle
                  disabled={loader}
                  className="input-group-merge"
                  id="login-password"
                  placeholder="Enter your password"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="form-check mb-1">
                <Input disabled={loader} type="checkbox" id="remember-me" />
                <Label className="form-check-label" for="remember-me">
                  Remember Me
                </Label>
              </div> */}
              {loader ?
                <div className="sipnner-container">
                  <ClipLoader />
                </div> :
                <Button color="primary" block disabled={loader}>
                  Sign in
                </Button>
              }
            </Form>
            <p style={{ fontSize: '16px' }} className="text-center mt-2">
              <span className="me-25">New on our platform?</span>
              <Link className={loader ? "disabled-link" : ""} to="/register">
                <span>Create an account</span>
              </Link>
            </p>
          </Col>
        </div>
      </div>
    </div>);
};

export default Login;
